import { throttle } from 'throttle-debounce';

export const headerCollapsePlugin = {
  afterRender({ updateHeaderProps, headerType, params }) {
    let collapsed;
    let lastYScrollPosition = window.scrollY;

    const checkCollapsed = (currentYScrollPosition) => {
      const isOnTop = currentYScrollPosition <= params.headerHeight;
      const deltaY = lastYScrollPosition - currentYScrollPosition;
      const isFastMove = deltaY > params.fastMoveScrollDelta;
      const direction = deltaY > 0 ? 'UP' : 'DOWN';
      if (direction === 'DOWN' && !isOnTop && !collapsed) {
        collapsed = true;
        updateHeaderProps({ collapsed });
      } else if (direction === 'UP' && (isFastMove || isOnTop) && collapsed) {
        collapsed = false;
        updateHeaderProps({ collapsed });
      }
    };

    const onScrollHandler = throttle(100, () => {
      const currentYScrollPosition = window.scrollY;
      if (headerType === 'mobile') {
        checkCollapsed(currentYScrollPosition);
      }
      lastYScrollPosition = currentYScrollPosition;
    });
    window.addEventListener('scroll', onScrollHandler, false);
  },
};
